import { render, staticRenderFns } from "./UpdateDemoPage.vue?vue&type=template&id=5f275472&scoped=true"
import script from "./UpdateDemoPage.vue?vue&type=script&lang=js"
export * from "./UpdateDemoPage.vue?vue&type=script&lang=js"
import style0 from "./UpdateDemoPage.vue?vue&type=style&index=0&id=5f275472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f275472",
  null
  
)

export default component.exports